"use strict";

import L from "leaflet";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.factory("leaflet", function() {
    return L;
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/leaflet/leaflet.js